// Broadcasts sign-out across same-origin tabs so the shared session tears down together.

const SIGN_OUT_KEY = 'session:signedOutAt'

export function broadcastSignOut(): void {
  try {
    window.localStorage.setItem(SIGN_OUT_KEY, String(Date.now()))
  } catch {
    // localStorage unavailable
  }
}

export function onSignOutBroadcast(handler: () => void): () => void {
  const listener = (event: StorageEvent): void => {
    if (event.key === SIGN_OUT_KEY && event.newValue) {
      handler()
    }
  }
  window.addEventListener('storage', listener)
  return (): void => window.removeEventListener('storage', listener)
}
